"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LifeTable = (function () {
    function LifeTable() {
        this._startAge = 0;
        this._maleArray = [];
        this._femaleArray = [];
    }
    LifeTable.prototype.initialise = function (startAge, maleArray, femaleArray) {
        this._startAge = startAge;
        this._maleArray = maleArray;
        this._femaleArray = femaleArray;
    };
    LifeTable.prototype.lifeExpectancy = function (age, gender) {
        if (gender === "Male" || gender === 1) {
            return this._maleArray[(age - this._startAge)];
        }
        else {
            return this._femaleArray[(age - this._startAge)];
        }
    };
    Object.defineProperty(LifeTable.prototype, "startAge", {
        get: function () {
            return this._startAge;
        },
        enumerable: true,
        configurable: true
    });
    return LifeTable;
}());
exports.LifeTable = LifeTable;
//# sourceMappingURL=LifeTable.js.map